import React from 'react';
import DataList from '../DataList';
import ApiConfigFactory from '../../configurations/ApiConfigFactory';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import '../../styles/LabTestRequestList.css';
import { useAuth } from '../../hooks/useAuth';

const LabTestRequestList = ({patient, viewName,admissionId}) => {
  console.log("View: ",viewName);
  const location = useLocation();
  const { hasPermission } = useAuth();

  const id = patient ? patient.patient_id : undefined;

  const viewTitle = viewName?viewName:'Lab';

  const title = patient
    ? `Viewing Lab and Radiology Requests for ${patient.patient_first_name} ${patient.patient_last_name} - ${patient.patient_number}`
    : `${viewTitle} Test Requests`;

  // Initialize apiConfig using ApiConfigFactory with the patient id (if available)
  const apiConfig = new ApiConfigFactory('lab/lab-requests', title, 'patient_id', id);
  apiConfig.defaultSortAsc = false;
  apiConfig.defaultSortFieldId = 'id';
  apiConfig.path = '/lab-requests';
  apiConfig.allowAdd = false;
  apiConfig.allowDelete = false;
  apiConfig.useLocalCaching = (patient && Object.keys(patient).length > 0) ? false : true;
  if(viewName ==='Laboratory' || viewName === 'Radiology') {
    console.log("Lab Request View Name: ", viewName);
    apiConfig.systemFilters= [{ name: 'request_type', value: viewName},];
  }
    // Conditionally add bulkAction if the user has permission.
    if (hasPermission('/lab-requests/mark-paid', 'View')) {
      apiConfig.addBulkAction({ name: 'Mark as Paid', endpoint: '/hospital-portal/api/lab/lab-requests/markRequestPaid' });
    }
    if (hasPermission('/lab-requests/mark-canceled', 'View')) {
      apiConfig.addBulkAction({ name: 'Cancel Request', endpoint: '/hospital-portal/api/lab/lab-requests/markRequestCanceled' });
    }
  
   apiConfig.addConditionalStyle("Status",{
    "type": "text",
    "conditions": {
      "matches": {
          "canceled": {"color": "black","backgroundColor":"lightgrey"},
          "complete": {"color": "white","backgroundColor":"green"},
          "paid": {"color": "green", "backgroundColor": "white"}
      },
        "default": {"color":"black","backgroundColor":"white"}
    }
  });

    // Configure fields, columns, and other properties
  apiConfig
    .addField({
      name: 'id',
      label: 'Request ID',
      type: 'text',
      identifier: true,
      disabled: true,
      tab: 'Main'
    })
    .addField({
      name: 'patient_id',
      label: 'Patient ID',
      type: 'text',
      required: true,
      disabled: true,
      tab: 'Main',
      defaultValue: id
    })
    .addField({
      name: 'requested_by',
      label: 'Requester',
      type: 'text',
      disabled: true,
      tab: 'Main'
    })
    .addField({
      name: 'status',
      label: 'Status',
      type: 'dropdown',
      required: true,
      tab: 'Main',
      disabled: true
    })
    .addField({
      name: 'invoiced',
      label: 'Invoiced?',
      type: 'checkbox',
      required: false,
      tab: 'Admin'
    })
    .addField({
      name: 'createdAt',
      label: 'Request Date',
      type: 'datetime',
      disabled: true,
      tab: 'Main'
    })
    .addField({
      name: 'updatedBy',
      label: 'Updated By',
      type: 'text',
      disabled: true,
      tab: 'Admin'
    })
    .addField({
      name: 'xRayFile',
      label: 'X-Ray File 1',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'xRayFile2',
      label: 'X-Ray File 2',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'xRayFile3',
      label: 'X-Ray File 3',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'xRayFile4',
      label: 'X-Ray File 4',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'ECGFile',
      label: 'ECG File',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'CTScanFile',
      label: 'CT Scan File',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'MRIFile',
      label: 'MRI File',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'EchoFile',
      label: 'Echochardiogram',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addField({
      name: 'EndoscopyFile',
      label: 'Endoscopy File',
      type: 'file',
      required: false,
      tab: 'Files'
    })
    .addStaticDropdownField({
      name: 'status',
      options: [
        { id: 'unpaid', name: 'Unpaid' },
        { id: 'paid', name: 'Paid' },
        { id: 'complete', name: 'Complete' }
      ]
    })
    .addTab({ name: 'Main', roles: 'all', default: true })
    .addTab({ name: 'Admin', roles: 'Admin' })
    .addTab({ name: 'Files', securityPath: '/lab-requests/view-files', permission: 'View' })
      //roles: 'Admin,Doctor, Nurse, Accountant,Manager,Scan-Admin,IT,Medical Director,Finance Manager' })
    
    .addColumn({
      id: 'id',
      name: 'ID',
      selector: (row) => row.id,
      type: 'text',
      identifier: true,
       width: '75px'
    });

if(hasPermission('/patient-card','View')) {
    apiConfig
    .addColumn({
      name: 'Patient Number',
      type: 'link',
      label: (row) => row.Patient.patient_number,
      path: '/patient-card',
      getState: (row) => ({ patient: row.Patient }),
      selector: (row) => row.Patient.patient_number,
      sortable: true,
      filterable: true,
      filterSelector: 'Patient.patient_number',
      width: '100px',
      omit: viewName=='PatientCard'
    });
    } else {
      apiConfig
      .addColumn({
        name: 'Patient Number',
        selector: (row) => row.Patient.patient_number,
        sortable: true,
        filterable: true,
        filterSelector: 'Patient.patient_number',
        width: '100px',
        omit: viewName=='PatientCard'
      });
    }
      apiConfig
      .addColumn({
        name: 'Patient Name',
        selector: (row) => `${row.Patient?.patient_first_name} ${row.Patient?.patient_last_name}`,
        sortable: true,
        width: '150px',
        omit:viewName=='PatientCard'
      });

    apiConfig
      .addColumn ({
        name: 'Type',
        selector: (row) => row.request_type,
        sortable: true,
        filterable: true,
        filterSelector: 'request_type',
        width: '100px',
        omit:viewName!='PatientCard'
      })
 

  apiConfig
    .addColumn({
      name: 'Requested By',
      selector: (row) => row.requested_by,
      sortable: true,
      filterable: true,
      filterSelector: 'requested_by',
      width: '150px'
    })
    .addColumn({
      name: 'Branch',
      selector: (row) => row.requested_branch,
      sortable: true,
      filterable: true,
      filterSelector: 'requested_branch',
      width: '75px'
    })
    .addColumn({
      name: 'Status',
      selector: (row) => row.status,
      sortable: true,
      filterable: true,
      filterSelector: 'status',
      width: '75px'
    })
    .addColumn({
      name: 'Request Date',
      selector: (row) => row.createdAt,
      type: 'datetime',
      sortable: true
    })
    .addColumn({
      name: 'Report',
      type: 'link',
      label: 'View Report',
      path: '/lab-report',
      getState: (row) => ({
        id: row.id,         // The request id
        patient: patient    // The patient object
      }),
      visible: (row) => hasPermission('/lab-report', 'View') && row.status === 'complete',
      width: '100px'
    })
    .addColumn({
      name: 'Lab Actions',
      type: 'link',
      label: 'Input Results',
      path: '/lab-request-details',
      getState: (row) => ({ request: row }),
      visible: (row) => row.status != 'canceled' && hasPermission(row.request_type === 'Radiology' ? '/lab-request-detail-radiology' : '/lab-request-detail', 'View') && (row.request_type === 'Radiology' || row.Patient.patient_type === 'Company' || row.Patient.patient_type === 'Staff' || (row.Patient.patient_type === 'Private' && (row.status === 'paid' || row.status === 'complete'))),
      width: '100px'
    });

  return (
    <div className="patient-list-container">
      {patient && hasPermission('/lab-request-form', 'Add') && (
        <div className="lab-request-link">
          <Link to="/lab-request-form" state={{ patient, admissionId }}>
            Create Lab Request
          </Link>
        </div>
      )}
      <DataList apiConfig={apiConfig} columns={apiConfig.columns} />
    </div>
  );
};

export default LabTestRequestList;
